import { CdkDragEnter, CdkDropList, DragRef, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { IDragDropConfiguration } from '@core/interfaces/idrag-drop-configuration';
import { ScrollService } from '@core/services/scroll.service';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-drag-drop-multi-direction',
    templateUrl: './drag-drop-multi-direction.component.html',
    styleUrls: ['./drag-drop-multi-direction.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DragDropMultiDirectionComponent {
  faEdit = faEdit;
  faTrash = faTrash;

  constructor(private scrollService: ScrollService) {}

  @ViewChild(CdkDropList) placeholder!: CdkDropList;
  @Input() items!: any;
  @Input() isEditable: boolean = false;
  @Input() configuration!: IDragDropConfiguration;
  @Output() arrayChanged: EventEmitter<any> = new EventEmitter();
  @Output() iconClick: EventEmitter<any> = new EventEmitter();
  @Output() deleteIconClick: EventEmitter<any> = new EventEmitter();
  @Output() editIconClick: EventEmitter<any> = new EventEmitter();

  private target?: CdkDropList | null;
  private targetIndex!: number;
  private source?: CdkDropList | null;
  private sourceIndex!: number;
  private dragRef?: DragRef | null;

  boxWidth = '200px';
  boxHeight = '200px';

  ngAfterViewInit() {
    if (this.placeholder) {
      const placeholderElement = this.placeholder.element.nativeElement;

      placeholderElement.style.display = 'none';
      placeholderElement!.parentNode!.removeChild(placeholderElement);
    }
  }

  add() {
    this.items.push(this.items.length + 1);
  }

  shuffle() {
    this.items.sort(function () {
      return 0.5 - Math.random();
    });
  }

  onDropListDropped() {
    if (!this.target) {
      return;
    }

    const placeholderElement: HTMLElement =
      this.placeholder.element.nativeElement;
    const placeholderParentElement: HTMLElement =
      placeholderElement!.parentElement!;

    placeholderElement.style.display = 'none';

    placeholderParentElement.removeChild(placeholderElement);
    placeholderParentElement.appendChild(placeholderElement);
    placeholderParentElement.insertBefore(
      this.source!.element.nativeElement,
      placeholderParentElement.children[this.sourceIndex]
    );

    if (this.placeholder._dropListRef.isDragging()) {
      this.placeholder._dropListRef.exit(this.dragRef!);
    }

    this.target = null;
    this.source = null;
    this.dragRef = null;

    if (this.sourceIndex !== this.targetIndex) {
      moveItemInArray(this.items, this.sourceIndex, this.targetIndex);
      this.arrayChanged.emit(true);
    }
  }

  onDropListEntered({ item, container }: CdkDragEnter) {
    if (container == this.placeholder) {
      return;
    }

    const placeholderElement: HTMLElement =
      this.placeholder.element.nativeElement;
    const sourceElement: HTMLElement = item.dropContainer.element.nativeElement;
    const dropElement: HTMLElement = container.element.nativeElement;
    const dragIndex: number = Array.prototype.indexOf.call(
      dropElement!.parentElement!.children,
      this.source ? placeholderElement : sourceElement
    );
    const dropIndex: number = Array.prototype.indexOf.call(
      dropElement!.parentElement!.children,
      dropElement
    );

    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = item.dropContainer;

      placeholderElement.style.width = this.boxWidth + 'px';
      placeholderElement.style.height = this.boxHeight + 40 + 'px';

      sourceElement!.parentElement!.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = container;
    this.dragRef = item._dragRef;

    placeholderElement.style.display = '';

    dropElement!.parentElement!.insertBefore(
      placeholderElement,
      dropIndex > dragIndex ? dropElement.nextSibling : dropElement
    );

    this.placeholder._dropListRef.enter(
      item._dragRef,
      item.element.nativeElement.offsetLeft,
      item.element.nativeElement.offsetTop
    );
  }

  performEditAction(item: any) {
    this.editIconClick.emit(item);
    this.scrollToTarget();
  }

  scrollToTarget() {
    this.scrollService.triggerScrollToElement('editSection');
  }

}
